import { useEffect, useState } from "react";
import { useEditor, EditorContent } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import Link from "@tiptap/extension-link";
import Image from "@tiptap/extension-image";
import TextStyle from "@tiptap/extension-text-style";
import Color from "@tiptap/extension-color";
import Highlight from "@tiptap/extension-highlight";
import Underline from "@tiptap/extension-underline";
import TextAlign from "@tiptap/extension-text-align";
import { toHtml } from "@/lib/richText";
import { EditorToolbar } from "@/components/EditorToolbar";

export const RichTextEditor = ({ value, onChange, testId = "rich-editor" }) => {
  const [source, setSource] = useState(false);
  const editor = useEditor({
    extensions: [
      StarterKit.configure({ heading: { levels: [2, 3, 4] } }),
      Underline, TextStyle, Color, Highlight.configure({ multicolor: true }),
      Link.configure({ openOnClick: false, autolink: true }),
      Image.configure({ HTMLAttributes: { class: "rte-img" } }),
      TextAlign.configure({ types: ["heading", "paragraph"] }),
    ],
    content: toHtml(value || ""),
    onUpdate: ({ editor: e }) => onChange(e.getHTML()),
  });

  useEffect(() => {
    if (editor && !source && editor.getHTML() !== toHtml(value || "")) {
      editor.commands.setContent(toHtml(value || ""), false);
    }
  }, [source]); // eslint-disable-line react-hooks/exhaustive-deps

  if (!editor) return null;
  return (
    <div className="overflow-hidden rounded-md border border-slate-200 bg-white" data-testid={testId}>
      <EditorToolbar editor={editor} source={source} toggleSource={() => setSource((s) => !s)} testId={testId} />
      {source ? (
        <textarea
          value={value || ""}
          onChange={(e) => onChange(e.target.value)}
          className="block min-h-[280px] w-full resize-y bg-slate-950 p-4 font-mono text-xs leading-relaxed text-emerald-200 outline-none"
          data-testid={`${testId}-source`}
        />
      ) : (
        <EditorContent editor={editor} className="rich-content rte-editable" data-testid={`${testId}-content`} />
      )}
    </div>
  );
};
